import { registerPin } from '@/api/server/user/create';
import { useNavigate } from 'react-router-dom';

import RandomKeypad from '@/component/common/random-keypad';
import SecretNumberDisplay from '@/component/common/secret-number-display';
import SFStepper from '@/component/common/sf-stepper';
import TopBackButton from '@/component/common/top-back-button';
import { SFPalette } from '@/lib/color';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useJoinInfo } from '@/store/zustand/store';

export default function RegisterPin() {
  const navigate = useNavigate();
  const [secretNumber, setSecretNumber] = useState('');
  const [secretNumberConfirm, setSecretNumberConfirm] = useState('');
  const [isConfirmed, setIsConfirmed] = useState(false);
  const joinInfo = useJoinInfo();

  useEffect(() => {
    if (secretNumber && secretNumberConfirm && secretNumber === secretNumberConfirm) {
      (async () => {
        const payload = {
          pin: secretNumber,
          email: joinInfo.email,
        };
        const re = await registerPin(payload);
        if (re.ret_code !== 200) {
          toast.error(re.msg);
          initStatus();
          return;
        }
        navigate('/wellcome');
      })();
    } else if (secretNumber.length === 6 && secretNumberConfirm.length === 6 && secretNumber !== secretNumberConfirm) {
      toast.error('핀번호가 일치하지 않습니다.');
      initStatus();
    }

    return () => {};
  }, [secretNumber, secretNumberConfirm]);

  const initStatus = () => {
    setIsConfirmed(false);
    setSecretNumber('');
    setSecretNumberConfirm('');
  };

  const onSuccess = () => {
    setIsConfirmed(true);
  };

  return (
    <Container maxWidth="sm">
      <Box position="sticky" top={0} bgcolor="white" zIndex={100}>
        <TopBackButton
          title="회원가입"
          boxProps={{
            mb: 2,
          }}
        />
        <SFStepper
          steps={['1', '2', '3', '4']}
          activeStep={2}
          stepperProps={{
            sx: {
              width: 200,
              ml: '-10px',
              pb: 2,
            },
          }}
        />
      </Box>
      <Box pt={4}>
        {isConfirmed ? (
          <>
            <Typography variant="h4" mb={2.5}>
              <b>PIN번호 6자리</b>를
              <br />
              다시 입력해 주세요.
            </Typography>
            <Stack direction="row" mb={5}>
              <Typography
                variant="body2"
                onClick={() => {
                  navigate('/wellcome');
                }}
                color={SFPalette.grey4}
              >
                건너띄기
              </Typography>
              <ChevronRight
                sx={{
                  color: SFPalette.lightGrey2,
                }}
              />
            </Stack>
          </>
        ) : (
          <Typography variant="h4" mb={5}>
            보안 및 관리를 위해
            <br />
            <b>PIN번호 6자리</b>를 입력해 주세요.
            <Stack direction="row" mb={3.5}>
              <Typography
                variant="body2"
                onClick={() => {
                  navigate('/wellcome');
                }}
                color={SFPalette.grey4}
              >
                건너띄기
              </Typography>
              <ChevronRight
                sx={{
                  color: SFPalette.lightGrey2,
                }}
              />
            </Stack>
          </Typography>
        )}
        <SecretNumberDisplay value={isConfirmed ? secretNumberConfirm : secretNumber} />
        <Box position="absolute" bottom={0} left={0} mb={2}>
          <RandomKeypad
            value={isConfirmed ? secretNumberConfirm : secretNumber}
            onChange={isConfirmed ? setSecretNumberConfirm : setSecretNumber}
            onSuccess={onSuccess}
          />
        </Box>
      </Box>
    </Container>
  );
}
